import { DateRdv } from "../components/dateRdv";
import dateFormat from "dateformat";

export class RdvController {
    constructor() {
        this.navigateSteps();
        this.formHandler();
        this.nextStepHandler();
        document.querySelector("#RdvDateSetupForm").addEventListener("submit", function(e){
            console.log('ready submit');
            let handler = new DateRdv();
            handler.setIds();
            handler.fetchcall();
            e.preventDefault();
        });
    }

    sanitizeString(str){
        str = str.replace(/\s/g, '-');
        str = str.normalize("NFD").replace(/\p{Diacritic}/gu, "");
        str = str.toLowerCase();

        return str.trim();
    }

    navigateSteps() {
        /**
         * Define a function to navigate betweens form steps.
         * It accepts one parameter. That is - step number.
         */
        const navigateToFormStep = (stepNumber) => {
            /**
             * Hide all form steps.
             */
            document.querySelectorAll(".form-step").forEach((formStepElement) => {
                formStepElement.classList.add("d-none");
            });
            /**
             * Mark all form steps as unfinished.
             */
            document.querySelectorAll(".form-stepper-list").forEach((formStepHeader) => {
                formStepHeader.classList.add("form-stepper-unfinished");
                formStepHeader.classList.remove("form-stepper-active", "form-stepper-completed");
            });
            /**
             * Show the current form step (as passed to the function).
             */
            document.querySelector("#step-" + stepNumber).classList.remove("d-none");
            /**
             * Select the form step circle (progress bar).
             */
            const formStepCircle = document.querySelector('li[step="' + stepNumber + '"]');
            /**
             * Mark the current form step as active.
             */
            formStepCircle.classList.remove("form-stepper-unfinished", "form-stepper-completed");
            formStepCircle.classList.add("form-stepper-active");
            /**
             * Loop through each form step circles.
             * This loop will continue up to the current step number.
             * Example: If the current step is 3,
             * then the loop will perform operations for step 1 and 2.
             */
            for (let index = 0; index < stepNumber; index++) {
                /**
                 * Select the form step circle (progress bar).
                 */
                const formStepCircle = document.querySelector('li[step="' + index + '"]');
                /**
                 * Check if the element exist. If yes, then proceed.
                 */
                if (formStepCircle) {
                    /**
                     * Mark the form step as completed.
                     */
                    formStepCircle.classList.remove("form-stepper-unfinished", "form-stepper-active");
                    formStepCircle.classList.add("form-stepper-completed");
                }
            }
        };
        /**
         * Select all form navigation buttons, and loop through them.
         */
        document.querySelectorAll(".btn-navigate-form-step").forEach((formNavigationBtn) => {

            /**
             * Get Value of the center for url params
             */
            let center;
            let centers = document.querySelectorAll('input[type=radio][name="center-item-radio"]');

            centers.forEach((radio) => {
                if (radio.checked) {
                    center = this.sanitizeString(radio.value);
                }

                radio.addEventListener('change',()=> {
                    center = this.sanitizeString(radio.value);
                });
            });

            /**
             * Add a click event listener to the button.
             */
            formNavigationBtn.addEventListener("click", () => {
                /**
                 * Get the value of the step.
                 */
                const stepNumber = parseInt(formNavigationBtn.getAttribute("step_number"));

                let data = {
                    'civilite'    : document.querySelector('.civilite-select'),
                    'firstname'   : document.querySelector('input[type=text][name="firstname"]'),
                    'lastname'    : document.querySelector('input[type=text][name="lastname"]'),
                    'email'       : document.querySelector('input[type=email][name="email"]'),
                    'tel'         : document.querySelector('input[type=text][name="tel"]'),
                    'address'     : document.querySelector('input[type=text][name="address"]'),
                    'cp'          : document.querySelector('input[type=text][name="cp"]'),
                    'birthDate'   : document.querySelector('input[type=date][name="birthDate"]')
                };

                if (stepNumber === 4) {
                    if(data.civilite.value === "") {
                        var att = document.createAttribute("required");
                        data.civilite.setAttributeNode(att);
                        data.civilite.classList.add('invalid');
                    }
                    if(data.firstname.value === "") {
                        var att = document.createAttribute("required");
                        data.firstname.setAttributeNode(att);
                        data.firstname.classList.add('invalid');
                    }
                    if(data.lastname.value === "") {
                        var att = document.createAttribute("required");
                        data.lastname.setAttributeNode(att);
                        data.lastname.classList.add('invalid');
                    }
                    if(data.email.value === "") {
                        var att = document.createAttribute("required");
                        data.email.setAttributeNode(att);
                        data.email.classList.add('invalid');
                    }
                    if(data.tel.value === "") {
                        var att = document.createAttribute("required");
                        data.tel.setAttributeNode(att);
                        data.tel.classList.add('invalid');
                    }
                    if(data.address.value === "") {
                        var att = document.createAttribute("required");
                        data.address.setAttributeNode(att);
                        data.address.classList.add('invalid');
                    }
                    if(data.cp.value === "") {
                        var att = document.createAttribute("required");
                        data.cp.setAttributeNode(att);
                        data.cp.classList.add('invalid');
                    }
                    if(data.birthDate.value === "") {
                        var att = document.createAttribute("required");
                        data.birthDate.setAttributeNode(att);
                        data.birthDate.classList.add('invalid');
                    }
                    else {
                        if (data.civilite.classList.contains('invalid')) {
                            data.civilite.classList.remove('invalid');
                        }
                        if (data.firstname.classList.contains('invalid')) {
                            data.firstname.classList.remove('invalid');
                        }
                        if (data.lastname.classList.contains('invalid')) {
                            data.lastname.classList.remove('invalid');
                        }
                        if (data.email.classList.contains('invalid')) {
                            data.email.classList.remove('invalid');
                        }
                        if (data.tel.classList.contains('invalid')) {
                            data.tel.classList.remove('invalid');
                        }
                        if (data.address.classList.contains('invalid')) {
                            data.address.classList.remove('invalid');
                        }
                        if (data.cp.classList.contains('invalid')) {
                            data.cp.classList.remove('invalid');
                        }
                        if (data.birthDate.classList.contains('invalid')) {
                            data.birthDate.classList.remove('invalid');
                        }
                        /**
                         * Call the function to navigate to the target form step.
                         */
                        navigateToFormStep(stepNumber);
                    }
                }
                else {
                    /**
                     * Call the function to navigate to the target form step.
                     */
                    navigateToFormStep(stepNumber);
                }

                var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?center='+ center;
                window.history.pushState({ path: refresh }, '', refresh);

            });
        });
        let buttonNextFirstStep = document.querySelector('#next-first-step');
        buttonNextFirstStep.addEventListener('click', () => {
            let handle = new DateRdv();
            handle.setIds();
            handle.fetchDates();
        });
    }

    formHandler(){
        const data = {
            'civilite'      : document.querySelector('#civilite'),
            'firstname'     : document.querySelector('#firstname'),
            'lastname'      : document.querySelector('#lastname'),
            'visionType'    : document.querySelector('#vision-type'),
            'email'         : document.querySelector('#email'),
            'tel'           : document.querySelector('#tel'),
            'address'       : document.querySelector('#address'),
            'cp'            : document.querySelector('#cp'),
            'birthDate'     : document.querySelector('#birth-date'),
            'centerLabel'   : document.querySelector('#label-center'),
            'centerInput'   : document.querySelector('#rdv-center'),
        };

        let centers = document.querySelectorAll('input[type=radio][name="center-item-radio"]');

        centers.forEach((center) => {
            if (center.checked) {
                data.centerLabel.innerHTML   = "Centre de<br>" + center.value;
                data.centerInput.innerHTML   = center.value;
            }

            center.addEventListener('change',()=> {
                data.centerLabel.innerHTML   = "Centre de<br>" + center.value;
                data.centerInput.innerHTML   = center.value;
            });
        });

        let visionTypes = document.querySelectorAll('input[type=checkbox][name="checkbox-vision-type"]');

        visionTypes.forEach(visionType => visionType.addEventListener('change',()=> {
            let currentVisionType = visionType.value;

            if (data.visionType.innerHTML.includes(currentVisionType)) {
                data.visionType.innerHTML = data.visionType.innerHTML.replace(currentVisionType + ' ','');
            }else {
                data.visionType.innerHTML += currentVisionType + " ";
            }
        }));

        let selectCivilite = document.querySelector('.civilite-select');

        selectCivilite.addEventListener('change', () => {
            data.civilite.innerHTML = selectCivilite.value;
        });

        let inputLastname = document.querySelector('input[type=text][name="lastname"]');

        inputLastname.addEventListener('change',()=> {
            data.lastname.innerHTML = inputLastname.value;
        });

        let inputFirstname = document.querySelector('input[type=text][name="firstname"]');

        inputFirstname.addEventListener('change',()=> {
            data.firstname.innerHTML = inputFirstname.value;
        });

        let inputMail = document.querySelector('input[type=email][name="email"]');

        inputMail.addEventListener('change',()=> {
            data.email.innerHTML = inputMail.value;
        });

        let inputTel = document.querySelector('input[type=text][name="tel"]');

        inputTel.addEventListener('change',()=> {
            data.tel.innerHTML = inputTel.value;
        });

        let inputAddress = document.querySelector('input[type=text][name="address"]');

        inputAddress.addEventListener('change',()=> {
            data.address.innerHTML = inputAddress.value;
        });

        let inputCp = document.querySelector('input[type=text][name="cp"]');

        inputCp.addEventListener('change',()=> {
            data.cp.innerHTML = inputCp.value;
        });

        let inputbirthDate = document.querySelector('input[type=date][name="birthDate"]');

        inputbirthDate.addEventListener('change',()=> {
            data.birthDate.innerHTML = dateFormat(new Date(inputbirthDate.value),'dd-mm-yyyy');
        });

        let selectCiviliteWrapper = document.querySelector('.civilite-select-wrapper');

        document.addEventListener('click', function (e) {
            let targetElement = e.target;
            if (targetElement === selectCiviliteWrapper.querySelector('.civilite-select')) {
                if (selectCiviliteWrapper.classList.contains('civilite-select-wrapper-open')) {
                    selectCiviliteWrapper.classList.remove('civilite-select-wrapper-open');
                }
                else {
                    selectCiviliteWrapper.classList.add('civilite-select-wrapper-open');
                }
            }
            else {
                if (selectCiviliteWrapper.classList.contains('civilite-select-wrapper-open')) {
                    selectCiviliteWrapper.classList.remove('civilite-select-wrapper-open');
                }
            }
        });
    }

    nextStepHandler(){
        let centers     = document.querySelectorAll('input[type=radio][name="center-item-radio"]');
        let consent    = document.querySelector('input[type=checkbox][name="checkbox-consent"]');
        let nextButton = document.querySelector('.button-next');

        centers.forEach((center) => {
            if (center.checked) {
                nextButton.removeAttribute("disabled");
            }
            center.addEventListener('change',()=> {
                nextButton.removeAttribute("disabled");
            });
        });

        consent.addEventListener('change',()=> {
            consent.parentElement.parentElement.querySelector('.button-next').removeAttribute("disabled");
        });
    }
}